//登录用户信息
const userData = null;
const token = "";

export default {
    userData,
    token
};


// WEBPACK FOOTER //
// ./src/global/global.js